<template>
    <div class="simulator-wrap" :class="{ 'simulator-wrap-sjtu': owner === 'SJTU' }" @click="hideKeyboard">
        <div v-if="owner === 'SJTU' && app === ''" class="simulator-sjtu">交小财智能客服</div>
        <div v-if="owner === ''" class="simulator-hd">{{ h5ConfigData.title }}</div>
        <div v-if="owner !== 'SJTU'">
            <a
                v-show="h5ConfigData.topBannerFlag && h5ConfigData.topBannerLink && !DIALOG_STUDIO"
                target="_blank"
                :href="h5ConfigData.topBannerLink"
                class="simulator-banner"
            >
                <div :style="{ 'background-image': `url(${h5ConfigData.topBannerImage})` }"></div>
            </a>
            <div v-show="h5ConfigData.topBannerFlag && !h5ConfigData.topBannerLink" class="simulator-banner">
                <div :style="{ 'background-image': `url(${h5ConfigData.topBannerImage})` }"></div>
            </div>
        </div>

        <div
            ref="conversationNode"
            v-show="h5ConfigData.configId || owner === 'SJTU'"
            class="simulator-ct"
            :class="{ hasShare: h5ConfigData.bottomDiversionFlag || h5ConfigData.bottomShareFlag }"
        >
            <div class="notice" :style="{ color: skin }" v-if="noticeShow">
                <i class="el-icon-message-solid" :style="{ background: skinBg, color: skin }"></i>
                <div class="notice-content">{{ notice }}</div>
            </div>
            <template v-for="(item, index) in conversition">
                <user-input v-if="item.type === 'input'" :key="index" :content="item.content" :owner="owner"></user-input>
                <user-input-voice
                    v-if="item.type === 'input-voice'"
                    :key="index"
                    :content="item.content"
                    :asr="item.asr"
                    :isRequest="isRequest"
                    :curAudioSrc="curAudioSrc"
                    :owner="owner"
                    @setCurAudioSrc="setCurAudioSrc"
                ></user-input-voice>
                <answer
                    v-if="item.type === 'answer'"
                    :key="index"
                    :h5ConfigData="h5ConfigData"
                    :adDialogue="item.index"
                    :answerModel="item.content"
                    :previewImg.sync="previewImg"
                    :curAudioSrc="curAudioSrc"
                    :owner="owner"
                    :title="title"
                    @setCurAudioSrc="setCurAudioSrc"
                    @changeInput="changeInput"
                ></answer>
            </template>
        </div>
        <div v-cloak v-if="!h5ConfigData.configId && owner !== 'SJTU' && loading === false" class="simulator-empty">
            <div class="simulator-empty-desc">精灵离家出走了 T.T'</div>
        </div>
        <div class="simulator-loadEffect" v-if="loading === true">
            <div class="loadEffect">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="tabs">
            <span v-if="h5ConfigData.productId && faqMM.length" class="faq-btn" @click="getFaqList('click')">{{ title }}</span>
        </div>
        <simulator-ft
            :owner="owner"
            ref="simulatorFt"
            class="simulator-ft"
            :h5ConfigData="h5ConfigData"
            :conversition="conversition"
            :curAudioSrc.sync="curAudioSrc"
            :voiceLevel.sync="voiceLevel"
            :curRecordTime.sync="curRecordTime"
            :isRequest.sync="isRequest"
            :title="title"
            :search="search"
            @scrollToBottom="scrollToBottom"
            @showErrorTip="showErrorTip"
        ></simulator-ft>
        <simulator-bt class="simulator-bt" :h5ConfigData="h5ConfigData" :ifShowShareBoard.sync="ifShowShareBoard"></simulator-bt>
        <transition name="preview-img">
            <div v-if="previewImg" class="preview-img-wrap" @click="previewImg = ''">
                <img :src="previewImg" alt />
            </div>
        </transition>
        <transition name="error-tip">
            <div v-show="ifShowErrorTip" class="error-tip-wrap">{{ errorTip }}</div>
        </transition>
        <voice-transition :voiceLevel="voiceLevel" :curRecordTime="curRecordTime"></voice-transition>
        <share-transition :ifShowShareBoard.sync="ifShowShareBoard"></share-transition>
    </div>
</template>

<script>
import UserInput from './UserInput.vue'
import UserInputVoice from './UserInputVoice.vue'
import Answer from './Answer/index'
import SimulatorFt from './SimulatorFt.vue'
import SimulatorBt from './SimulatorBt.vue'
import ShareTransition from './transition/ShareTransition'
import VoiceTransition from './transition/VoiceTransition'
import H5ConfigModel from './H5ConfigModel'
// eslint-disable-next-line no-unused-vars
import { getH5Config, checkOauth, getOauth, DIALOG_STUDIO, appSource, sjtuRoot, getFaqList, getTitle, sendH5Message, H5AxiosSource, getNotice, getNavigation } from '../Service/api.js'
import AnswerModel from './AnswerModel'
const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return ''
}
let answerIndex = 0
export default {
  components: {
    UserInput,
    UserInputVoice,
    Answer,
    SimulatorFt,
    SimulatorBt,
    ShareTransition,
    VoiceTransition
  },

  data () {
    return {
      DIALOG_STUDIO,
      h5ConfigData: new H5ConfigModel(),
      voiceLevel: 0,
      curRecordTime: 0,
      isRequest: false,
      conversition: [],
      previewImg: '',
      curAudioSrc: '',
      ifShowErrorTip: false,
      errorTip: '',
      ifShowShareBoard: false,
      owner: '',
      app: '',
      loading: false,
      faqArray: [],
      faqMM: [],
      title: '',
      search: '',
      notice: '',
      skinBg: '',
      skin: '',
      noticeShow: false,
      menuList: [],
      activeIndex: 1,
      activeName: ''
    }
  },

  created () {
    const configId = getQueryVariable('param')
    const owner = getQueryVariable('owner')
    const code = getQueryVariable('code')
    if (owner) {
      this.owner = 'SJTU'
      if (code) {
        this.getOauthH5(code)
      } else {
        this.checkIsOauth()
      }
      this.initConversation('')
    } else {
      if (configId) {
        this.getH5Config(configId)
      }
      // this.initConversation(configId)
      const event = getQueryVariable('event')
      if (event === 'robotgame') {
        this.ifShowShareBoard = true
      }
      this.owner = ''
      this.search = window.location.search.substring(1).split('&')[1] ? decodeURIComponent(window.location.search.substring(1).split('&')[1]) : ''
    }
    if (navigator.userAgent.match(/TaskCenterApp\/([0-9]{1,2}\.[0-9]{1,2}\.[0-9]{1,2})/)) {
      // 在交我办中
      this.app = 'stju'
    } else {
      this.app = ''
    }
  },

  methods: {
    initConversation (configId) {
      const _configId = sessionStorage.getItem('configId')
      sessionStorage.setItem('configId', configId)
      if (_configId !== configId) {
        sessionStorage.removeItem('h5conversation')
        return
      }

      if (sessionStorage.getItem('h5conversation')) {
        try {
          const conversition = JSON.parse(
            sessionStorage.getItem('h5conversation')
          )
          if (Array.isArray(conversition)) {
            this.conversition = conversition
            this.scrollToBottom()
          }
        } catch (error) { }
      }
    },
    // 鉴权验证
    async checkIsOauth () {
      const result = await checkOauth()
      if (!result.data.result) {
        setTimeout(_ => {
          window.location.href = `https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=openid&client_id=UUOMZrMvXUFVtR7NwXbi&redirect_uri=${sjtuRoot}/ics/?owner=SJTU`
        }, 50)
      }
    },
    // oauth授权重定向
    getOauthH5 (code) {
      getOauth(code).then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('token', res.data.result.token)
          this.h5ConfigData = new H5ConfigModel({
            title: '交小财智能客服',
            welcomes: '您好，我是由财务计划处联合网络信息中心开发的“交小财智能客服”，财务相关问题都可以问我哦~'
          })
          this.initHeadMeta()
        } else {
          setTimeout(_ => {
            window.location.href = `https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=openid&client_id=UUOMZrMvXUFVtR7NwXbi&redirect_uri=${sjtuRoot}/ics/?owner=SJTU`
          }, 50)
        }
      }).catch(() => {
        setTimeout(_ => {
          window.location.href = `https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=openid&client_id=UUOMZrMvXUFVtR7NwXbi&redirect_uri=${sjtuRoot}/ics/?owner=SJTU`
        }, 50)
      })
    },
    getH5Config (configId) {
      this.loading = true
      getH5Config(configId).then(res => {
        this.h5ConfigData = new H5ConfigModel(res.result || {})
        if (res.code !== '200') {
          this.conversition = []
          this.loading = false
          return
        }
        this.getTitleData(res.result.productId)// 标题
        this.getNoticeData(res.result.productId)// 公告
        // this.initHeadMeta()

        this.getNavigationData(res.result.productId)// 导航
        setTimeout(() => {
          this.getFaqList('mounted') // 常见问题
        }, 500)

        if (this.search) {
          this.$nextTick(() => {
            this.beforeunloadFn()
          })
        }
        this.loading = false
      })
    },

    initHeadMeta () {
      const event = getQueryVariable('event')
      if (event === 'robotgame') {
        document.title = `${this.h5ConfigData.title}-找我聊天赢手机`
      } else {
        if (this.owner === 'SJTU') {
          document.title = '交小财智能客服'
        } else {
          document.title = `${this.h5ConfigData.title}-欢迎找我聊天`
        }
      }

      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      meta.name = 'image'
      meta.content = this.h5ConfigData.image
      head[0].appendChild(meta)
      const link = document.createElement('link')
      link.rel = 'apple-touch-icon-precomposed'
      link.href = this.h5ConfigData.image
      head[0].appendChild(link)
    },

    scrollToBottom () {
      this.$nextTick(() => {
        const node = this.$refs.conversationNode
        node.scrollTop = node.scrollHeight - node.offsetHeight
      })
    },

    changeInput (val) {
      this.$refs.simulatorFt.changeInput(val)
    },

    setCurAudioSrc (type, val = '') {
      this.$refs.simulatorFt.setCurAudioSrc(type, val)
    },

    hideKeyboard () {
      if (this.$refs.textInput && this.$refs.textInput.blur) {
        this.$refs.textInput.blur()
      }
    },

    showErrorTip (errorTip) {
      this.ifShowErrorTip = true
      this.errorTip = errorTip
      setTimeout(_ => {
        this.ifShowErrorTip = false
        setTimeout(_ => {
          this.errorTip = ''
        }, 300)
      }, 1200)
    },
    async getFaqList (type) {
      try {
        const res = await getFaqList(this.h5ConfigData.productId)
        console.log('---', type)

        this.faqArray = res
        this.addFaqH5conversation(type)
      } catch (error) {
        this.faqArray = []
        throw new Error(error)
      }
    },
    CompareDate (t1, t2) {
      const date = new Date()
      const a = t1.split(':')
      const b = t2.split(':')
      return date.setHours(a[0], a[1]) >= date.setHours(b[0], b[1])
    },
    addFaqH5conversation (type) {
      console.log('type', type)
      console.log('faqArray', this.faqArray)
      console.log('menuList', this.menuList)

      if (this.faqArray.length > 0 || this.menuList.length > 0) {
        const MM = []
        const conversition = []
        const FTIME = new Date().getTime()
        this.faqArray.forEach(f => {
          const { effectiveDate: { dateRange, timeRange } } = f
          if (dateRange.whole && timeRange.whole) {
            MM.push(f)
          } else if (!dateRange.whole && timeRange.whole) {
            const startTime = Date.parse(`${dateRange.from} 00:00:00`)
            const endTime = Date.parse(`${dateRange.end} 23:59:59`)
            if (startTime <= FTIME && FTIME <= endTime) {
              MM.push(f)
            }
          } else if (dateRange.whole && !timeRange.whole) {
            const startTime = this.CompareDate(new Date().toTimeString(), timeRange.from)
            const endTime = this.CompareDate(timeRange.end, new Date().toTimeString())
            if (startTime && endTime) {
              MM.push(f)
            }
          } else if (!dateRange.whole && !dateRange.whole) {
            const startDay = Date.parse(`${dateRange.from} 00:00:00`)
            const endTDay = Date.parse(`${dateRange.end} 23:59:59`)
            if (startDay <= FTIME && endTDay >= FTIME) {
              const startTime = this.CompareDate(new Date().toTimeString(), timeRange.from)
              const endTime = this.CompareDate(timeRange.end, new Date().toTimeString())
              if (startTime && endTime) {
                MM.push(f)
              }
            }
          }
        })
        this.faqMM = MM
        if (type === 'click') {
          conversition.push({
            type: 'answer',
            index: answerIndex++,
            content: {
              com: 'faq',
              faqs: MM
            }
          })
        } else {
          conversition.push({
            type: 'answer',
            index: answerIndex++,
            content: {
              menu: this.menuList,
              com: 'faq',
              faqs: MM
            }
          })
        }

        console.log('this.conversition676767', this.conversition)
        this.conversition = this.conversition.concat(conversition)
        sessionStorage.setItem(
          'h5conversation',
          JSON.stringify(this.conversition)
        )
        this.scrollToBottom()
      } else {
        this.faqMM = []
        this.menuList = []
      }
    },
    // 获取标题
    getTitleData (productId) {
      getTitle(productId).then(res => {
        this.title = res && res.title ? res.title : '常见问题'
      })
    },

    // 获取公告
    getNoticeData (productId) {
      getNotice(productId).then(res => {
        if (res.code === 0) {
          if (res.result && res.result.state) {
            let dateRange = res.result.effectTime ? res.result.effectTime.split('$')[0].split('=')[1] : ''
            let timeRange = res.result.effectTime ? res.result.effectTime.split('$')[1].split('=')[1] : ''
            let hours = new Date().getHours()
            let minutes = new Date().getMinutes()
            let second = new Date().getSeconds()
            let curDate = new Date()

            if (dateRange === 'all' && timeRange === 'all') {
              this.noticeShow = true
            } else if (dateRange === 'all' && timeRange !== 'all') {
              let time1 = timeRange.split(' - ')[0]
              let time2 = timeRange.split(' - ')[1]
              let lastTime = time1.split(':')[0] * 60 * 60 + time1.split(':')[1] * 60 + time1.split(':')[0] * 1
              let nowTime = hours * 60 * 60 + minutes * 60 + second * 1
              let nextTime = time2.split(':')[0] * 60 * 60 + time2.split(':')[1] * 60 + time2.split(':')[0] * 1
              if (nowTime > lastTime && nowTime < nextTime) {
                this.noticeShow = true
              } else {
                this.noticeShow = false
              }
            } else if (dateRange !== 'all' && timeRange === 'all') {
              if (curDate > new Date(dateRange.split(' - ')[0]) && curDate < new Date(dateRange.split(' - ')[1])) {
                this.noticeShow = true
              } else {
                this.noticeShow = false
              }
            } else {
              let last = dateRange.split(' - ')[0] + ' ' + timeRange.split(' - ')[0]
              let next = dateRange.split(' - ')[1] + ' ' + timeRange.split(' - ')[1]
              if (curDate > new Date(last) && curDate < new Date(next)) {
                this.noticeShow = true
              } else {
                this.noticeShow = false
              }
            }
            this.notice = res.result.content
            this.skin = res.result.skin
            switch (res.result.skin) {
              case '#FEB311':
                this.skinBg = 'rgba(255, 187, 40, 0.2)'
                break
              case '#F53F3F':
                this.skinBg = 'rgba(245, 63, 63, 0.2)'
                break
              case '#10CC4E':
                this.skinBg = 'rgba(16, 204, 78, 0.2)'
                break
              case '#4077FF':
                this.skinBg = 'rgba(64, 119, 255, 0.2)'
                break
            }
          } else {
            this.noticeShow = false
            this.notice = ''
            this.skin = ''
          }
        } else {
          this.noticeShow = false
          this.notice = ''
          this.skin = ''
        }
      })
    },
    // 获取导航
    async getNavigationData (productId) {
      const res = await getNavigation(productId)
      if (res.code === 0) {
        this.menuList = []
        const menuList = res.result
        menuList.forEach(item => {
          let dateRange = item.effectTime ? item.effectTime.split('$')[0].split('=')[1] : ''
          let timeRange = item.effectTime ? item.effectTime.split('$')[1].split('=')[1] : ''
          let hours = new Date().getHours()
          let minutes = new Date().getMinutes()
          let second = new Date().getSeconds()
          let curDate = new Date()
          if (dateRange === 'all' && timeRange === 'all') {
            this.menuList.push(item)
          } else if (dateRange === 'all' && timeRange !== 'all') {
            let time1 = timeRange.split(' - ')[0]
            let time2 = timeRange.split(' - ')[1]
            let lastTime = time1.split(':')[0] * 60 * 60 + time1.split(':')[1] * 60 + time1.split(':')[0] * 1
            let nowTime = hours * 60 * 60 + minutes * 60 + second * 1
            let nextTime = time2.split(':')[0] * 60 * 60 + time2.split(':')[1] * 60 + time2.split(':')[0] * 1
            if (nowTime > lastTime && nowTime < nextTime) {
              this.menuList.push(item)
            }
          } else if (dateRange !== 'all' && timeRange === 'all') {
            if (curDate > new Date(dateRange.split(' - ')[0]) && curDate < new Date(dateRange.split(' - ')[1])) {
              this.menuList.push(item)
            }
          } else {
            let last = dateRange.split(' - ')[0] + ' ' + timeRange.split(' - ')[0]
            let next = dateRange.split(' - ')[1] + ' ' + timeRange.split(' - ')[1]
            if (curDate > new Date(last) && curDate < new Date(next)) {
              this.menuList.push(item)
            }
          }
        })
        this.activeName = res.result[0].id
        console.log('this.menuList', this.menuList)
      }
    },

    postHandleAnswer (res, isInit) {
      if (
        isInit === 'init' &&
        res &&
        res.result &&
        res.result.result &&
        res.result.result.reply
      ) {
        res.result.result.reply = {}
      }

      if (
        res &&
        res.result &&
        res.result.result &&
        res.result.result.reply &&
        res.result.result.reply.Title === '服务出错拉'
      ) {
        res.result.result.reply = {}
        res.result.result.ttsUrl = ''
      }
    },
    beforeunloadFn () {
      console.log('++++')
      sendH5Message(
        this.search,
        this.h5ConfigData.productId,
        this.ifResVoice,
        this.h5ConfigData.voiceId,
        this.h5ConfigData.speed,
        this.h5ConfigData.volume
      )
        .then(res => {
          if (res.code !== '200') {
            this.$emit('showErrorTip', '发送消息失败')
            return
          }
          this.postHandleAnswer(res, false)
          if (res.result.artificial) { // 丰巢的转人工服务
            this.conversition.push({
              type: 'answer',
              index: answerIndex++,
              content: {
                ttsUrl: '',
                reply: {
                  CardType: 1,
                  Title: res.result.artificial.replyContent.trim().split('\n'),
                  empty: false
                }
              }
            })
          } else {
            this.conversition.push({
              type: 'input',
              content: this.search
            })

            this.conversition.push({
              type: 'answer',
              index: answerIndex++,
              content: new AnswerModel(res.result.result || {})
            })

            this.scrollToBottom()
          }
          sessionStorage.setItem(
            'h5conversation',
            JSON.stringify(this.conversition)
          )
          this.scrollToBottom()
        })
        .catch(err => {
          console.log(err)
          this.$emit('showErrorTip', '网络出错，请再次发送')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.simulator {
    &-wrap {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        overflow: hidden;
        width: 100%;
        background: #f8f8f8;
    }
    &-wrap-sjtu {
        max-width: 767px;
        margin: 0 auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    &-sjtu {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 80px;
        font-size: 12.5pt;
        font-weight: 500;
        color: #ffffff;
        background-color: #016aed;
        img {
            position: absolute;
            left: 22px;
            width: 12.5pt;
        }
    }

    &-hd {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        padding: 0 20px;
        font-size: 28px; /*px*/
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #34404d;
        background: #f5f5f5;
    }

    &-banner {
        display: block;
        height: 176px;

        div {
            height: 100%;
            background: linear-gradient(135deg, rgba(48, 35, 174, 1) 0%, rgba(200, 109, 215, 1) 100%) no-repeat center center;
            background-size: cover;
        }
    }

    &-empty {
        flex: 1;
        background: url('../assets/imgs/empty.jpg') no-repeat center 240px / 366px 348px;

        &-desc {
            position: relative;
            top: 660px;
            font-size: 28px; /*px*/
            font-weight: 500;
            text-align: center;
            color: #c3c7cb;
        }
    }

    &-ct {
        position: relative;
        flex: 1;
        padding: 32px 22px;
        // border: 2px solid #f2f1f1;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;

        &.hasShare {
            padding-bottom: 118px;
        }
        .notice {
            width: 100%;
            background: #ffffff;
            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
            border-radius: 12px;
            text-align: center;
            padding: 24px 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            &-content {
                font-size: 28px;
                font-weight: 500;
                line-height: 40px;
                text-align: left;
                margin-left: 30px;
                flex: 1;
            }
        }
        .el-icon-message-solid {
            width: 60px;
            height: 60px;
            border-radius: 30px;
            display: inline-table;
            text-align: center;
            line-height: 60px;
        }
    }

    &-ft {
        height: 140px;
        background: #f8f8f8;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #eaebec;
    }

    &-bt {
        position: absolute;
        bottom: 120px;
        left: 0;
        right: 0;
        height: 72px;
        opacity: 0.9;
    }
}

.preview-img {
    &-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        text-align: center;
        background: rgba(0, 0, 0, 0.85);
        -webkit-overflow-scrolling: touch;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            max-width: 100%;
            height: auto;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.22, 1);
        }
    }

    &-enter,
    &-leave-to {
        img {
            width: 0;
            height: 0;
            opacity: 0;
        }
    }

    &-enter-to {
        max-width: 100%;
        max-height: 100%;
        opacity: 1;
    }
}

.error-tip {
    &-wrap {
        position: fixed;
        z-index: 100;
        top: 120px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        min-width: 400px;
        padding: 30px 30px 30px 40px;
        border: 2px solid #fde2e2;
        border-radius: 8px;
        word-break: break-all;
        word-wrap: break-all;
        overflow: hidden;
        background-color: #fef0f0;
        transition: opacity 0.3s, top 0.4s;
    }

    &-enter,
    &-leave-to {
        top: 0;
        opacity: 0;
    }

    &-enter-to {
        opacity: 1;
    }
}

@media screen and (max-width: 767px) {
    .simulator-wrap-sjtu {
        font-family: PingFangSC, PingFang SC, Helvetica, Tahoma, Arial, Microsoft YaHei, Hiragino Sans GB, WenQuanYi Micro Hei, sans-serif !important;
        width: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
[v-cloak] {
    display: none;
}

.simulator-ct::-webkit-scrollbar {
    width: 6px;
    height: 12px;
}
.simulator-ct::-webkit-scrollbar-thumb {
    background-color: rgba(220, 222, 224, 0.7);
    border-radius: 3px;
}

.simulator-ct::-webkit-scrollbar-track {
    background-color: inherit;
}

.simulator-ct::-webkit-scrollbar-thumb:hover {
    background-color: rgba(220, 222, 224, 1);
}
.simulator-loadEffect {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
}
.loadEffect {
    width: 100px;
    height: 100px;
    position: relative;
    margin: 0 auto;
}
.loadEffect span {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #4e82ff;
    position: absolute;
    -webkit-animation: load 1.04s ease infinite;
}
@-webkit-keyframes load {
    0% {
        -webkit-transform: scale(1.2);
        opacity: 1;
    }
    100% {
        -webkit-transform: scale(0.3);
        opacity: 0.5;
    }
}
.loadEffect span:nth-child(1) {
    left: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.13s;
}
.loadEffect span:nth-child(2) {
    left: 14px;
    top: 14px;
    -webkit-animation-delay: 0.26s;
}
.loadEffect span:nth-child(3) {
    left: 50%;
    top: 0;
    margin-left: -10px;
    -webkit-animation-delay: 0.39s;
}
.loadEffect span:nth-child(4) {
    top: 14px;
    right: 14px;
    -webkit-animation-delay: 0.52s;
}
.loadEffect span:nth-child(5) {
    right: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.65s;
}
.loadEffect span:nth-child(6) {
    right: 14px;
    bottom: 14px;
    -webkit-animation-delay: 0.78s;
}
.loadEffect span:nth-child(7) {
    bottom: 0;
    left: 50%;
    margin-left: -10px;
    -webkit-animation-delay: 0.91s;
}
.loadEffect span:nth-child(8) {
    bottom: 14px;
    left: 14px;
    -webkit-animation-delay: 1.04s;
}
.faq-btn {
    cursor: pointer;
    display: inline-block;
    border: 1px solid #eaebec;
    margin: 16px 24px;
    border-radius: 12px;
    height: 70px;
    line-height: 70px;
    padding: 0 20px;
    background: #fff;
    color: #34404d;
    font-size: 26px;
}
.tabs {
    position: relative;
    padding: 32px 22px 0px;
    overflow-x: hidden;
    background: #f8f8f8;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.02);
    border-radius: 6px;
    .el-tabs {
        background: #ffffff;
        padding: 24px 24px 40px;
    }
    .el-tab-pane {
        padding-bottom: 40px;
        border-bottom: 1px solid #eaebec;
    }
    .subitem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        .discribe {
            display: flex;
            justify-content: center;
            align-items: center;
            a {
                font-size: 30px;
                font-weight: 600;
                color: #111e2e;
                line-height: 42px;
            }
        }
        .el-icon-arrow-right {
            font-size: 40px;
        }
    }
}
</style>
<style scoped>
.tabs >>> .el-tabs__item {
    font-size: 30px;
    font-weight: 600;
    color: #111e2e;
    line-height: 42px;
    margin-bottom: 10px;
}
.tabs >>> .el-tabs__header {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/index.vue